/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { SwUpdateBanner, useSw } from "@ops/sw/ui";
import { AppMetaInfo } from "@/spa/context/sw.tsx";
import { ShushApp, ShushAppContext, useShushAppSelect } from "@/spa/app/app.tsx";
import { Shell } from "@/spa/components/shell.tsx";
import { PlayView } from "@/spa/views/play.tsx";
import { ConfigView } from "@/spa/config/config.tsx";

function ShushViewSwitch() {
  const view = useShushAppSelect((s) => s.view);
  return view === "config" ? <ConfigView /> : <PlayView />;
}

export interface ShushMainPageProps {}
export function ShushMainPage(props: ShushMainPageProps) {
  const [app] = useState(() => new ShushApp());
  useEffect(() => {
    app.dispatch({ type: "init" });
    return () => app.dispose();
  }, [app]);
  const sw = useSw({ app: "shushgen", release: AppMetaInfo.release, enabled: AppMetaInfo.sw });

  return (
    <ShushAppContext.Provider value={app}>
      <Shell banner={<SwUpdateBanner sw={sw} />}>
        <ShushViewSwitch />
      </Shell>
    </ShushAppContext.Provider>
  );
}
